import FormErrors from "../FormErrors";
import axios from "axios";
import Guest from "./Guest";

export default class SubscriptionForm {

    constructor( manager ) {
        this.manager = manager;
        this.listeners = [];
        this.handleInput = this.__handleInput.bind(this);
        this.submit = this.__submit.bind(this);
        this.form = this.manager.getModal().querySelector('.subscribe-form');
        this.fields = this.form.querySelectorAll('input');
        this.fields
            .forEach(
                el => addEventListener( 'input', this.handleInput )
            );

        this.errors = new FormErrors( this.fields );
        this.input = {firstname: '', lastname: '', email: '', policy: 'off', agent: ''}
        this.form.querySelector('.button').addEventListener('click', this.submit)
    }

    setAgent( agent ) {
        this.input.agent = agent
    }

    __handleInput( ev ) {
        let name = ev.target.name;
        if( ev.target.type === 'checkbox' ) return this.input[name] = ( ev.target.checked ) ? 'on':'off';
        this.input[name] = ev.target.value;
    }

    __submit() {
        this.emit();
    }

    get( field ) {
        return this.input[field];
    }

    send() {
        let data = new FormData();
        for( let key in this.input ) data.append( key, this.input[key] );

        return new Promise( (resolve, reject) => {
            axios.post('/cisco/subscribe/guest', data)
                .then( response => {
                    let guest = new Guest( response.data );
                    resolve( guest )
                })
                .catch( errors => {
                    if( errors.response.status === 422 ) {
                        this.errors.record( errors.response.data.errors );
                    }
                    reject( errors.response )
                } )
        })
    }

    hide() {
        this.form.style.display = 'none';
    }

    show() {
        this.form.style.display = 'block';
    }

    addAction( callback ) {
        this.listeners.push( callback )
    }

    emit() {
        for( let callback of this.listeners ) callback();
    }
}